import React from 'react';
import styled from 'styled-components';

const E5Style = styled.svg``;

export const E5 = ({ color }) => {
	return (
		<E5Style
			xmlns='http://www.w3.org/2000/svg'
			width='17.123'
			height='22.272'
			viewBox='0 0 17.123 22.272'
		>
			<path
				id='wine'
				d='M871.921,553.188v2.573h7.061v-2.573Zm8.773.031h4.922v-3.053h-8.362v1.309h2.584a.855.855,0,0,1,.856.857v.888Zm4.922,1.026h-4.922v5.12a5.6,5.6,0,0,1-.06.787l.024,0a4.191,4.191,0,0,0,4.959-4.11v-1.8Zm-13.7,2.546v2.574a3.53,3.53,0,0,0,7.061,0V556.79Zm3.621-5.316v-2.166a.859.859,0,0,1,.856-.857h10.069a.861.861,0,0,1,.863.857v6.739a5.87,5.87,0,0,1-1.737,4.158v0l-.013.013a5.889,5.889,0,0,1-3.293,1.655v7.134h4.181a.857.857,0,1,1,0,1.714H871.057a.857.857,0,0,1,0-1.714h3.538v-4.472a5.31,5.31,0,0,1-2.856-1.471,5.252,5.252,0,0,1-1.531-3.7v-7.034a.854.854,0,0,1,.85-.857h4.485Zm.765,13.064v4.472h4.272v-7.134l-.23-.039c-.079-.019-.164-.033-.249-.052a5.312,5.312,0,0,1-3.792,2.753Z'
				transform='translate(-870.207 -548.452)'
				fill={color}
			/>
		</E5Style>
	);
};
